"use client";
import * as a from "react";
import * as m from "react-dom";
import { u as c } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { A as f, u as d } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { u as l } from "./useEventCallback-CjuAhyNz.mjs";
import { u as g } from "./useLatestRef-BZ_hd_SE.mjs";
function p(n, i = !1, r = !1) {
  const [t, s] = a.useState(n && i ? "idle" : void 0), [e, o] = a.useState(n);
  return n && !e && (o(!0), s("starting")), !n && e && t !== "ending" && !r && s("ending"), !n && !e && t === "ending" && s(void 0), c(() => {
    if (!n && e && t !== "ending" && r) {
      const u = f.request(() => {
        s("ending");
      });
      return () => {
        f.cancel(u);
      };
    }
  }, [n, e, t, r]), c(() => {
    if (!n || i)
      return;
    const u = f.request(() => {
      m.flushSync(() => {
        s(void 0);
      });
    });
    return () => {
      f.cancel(u);
    };
  }, [i, n]), c(() => {
    if (!n || !i)
      return;
    n && e && t !== "idle" && s("starting");
    const u = f.request(() => {
      s("idle");
    });
    return () => {
      f.cancel(u);
    };
  }, [i, n, e, s, t]), a.useMemo(() => ({
    mounted: e,
    setMounted: o,
    transitionStatus: t
  }), [e, t]);
}
function q(n) {
  const {
    enabled: i = !0,
    open: r,
    ref: t,
    onComplete: s
  } = n, e = g(r), o = l(s), u = d(t, r);
  a.useEffect(() => {
    i && u(() => {
      r === e.current && o();
    });
  }, [i, r, o, u, e]);
}
export {
  q as a,
  p as u
};
